<template>
	<div class="wrapper">
		<article class="weui-article">
			<section>
				<div class="weui-cell weui-cell_active weui-cell_access weui-cell_select weui-cell_select-after">
					<div class="weui-cell__hd" style="color: #0d0d0d"><label class="weui-label">券时长</label>
					</div>

					<div class="weui-cell__bd" @click="chooseRationType">
						{{ checkedCoupon }}
					</div>
				</div>
			</section>
		</article>


		<div class="qrCode-wrapper">

			<vue-qr :text="url" :margin="0" :size="250">
			</vue-qr>
		</div>


		<div class="weui-btn-area">

			<button class="weui-btn weui-btn_primary" @click="handleConfirm('plate')">确定</button>
		</div>


	</div>
</template>

<script>
import { getCouponKey } from "../../../api/coupon/rationFee";
import CryptoJS from 'crypto-js'
import vueQr from 'vue-qr';
import { mapGetters } from 'vuex'
import scan from '../../../api/coupon/scan'
import encrypt from '../../../utils/encrypt'
export default {
	name: "index",
	data() {
		return {
			parkinglotId: undefined,
			couponTaskId: undefined,
			checkedCoupon: undefined,
			checkedCouponId: null,
			url: undefined,
			isChecked: true,
			couponKey: undefined,
			checkedCouponOptions: [

				{
					value: '1',
					label: '一小时'
				},
				{
					value: '2',
					label: '二小时'
				},
				{
					value: '3',
					label: '三小时'
				},
				{
					value: '4',
					label: '四小时'
				},
				{
					value: '5',
					label: '五小时'
				},
				{
					value: '6',
					label: '六小时'
				},
				{
					value: '7',
					label: '七小时'
				},
				{
					value: '8',
					label: '八小时'
				},
				{
					value: '9',
					label: '九小时'
				},
				{
					value: '10',
					label: '十小时'
				},
				{
					value: '11',
					label: '十一小时'
				},
				{
					value: '12',
					label: '十二小时'
				},
				{
					value: '13',
					label: '十三小时'
				},
				{
					value: '14',
					label: '十四小时'
				},
				{
					value: '15',
					label: '十五小时'
				},
				{
					value: '16',
					label: '十六小时'
				},
				{
					value: '17',
					label: '十七小时'
				},
				{
					value: '18',
					label: '十八小时'
				},
				{
					value: '19',
					label: '十九小时'
				},
				{
					value: '20',
					label: '二十小时'
				},
				{
					value: '21',
					label: '二十一小时'
				},
				{
					value: '22',
					label: '二十二小时'
				},
				{
					value: '23',
					label: '二十三小时'
				},
				{
					value: '24',
					label: '二十四小时'
				},
			],
		}
	},
	components: {
		vueQr
	},
	computed: {
		...mapGetters(['taskId'])
	},
	created() {
		this.checkedCoupon = this.checkedCouponOptions[0].label;
		this.checkedCouponId = this.checkedCouponOptions[0].value;
		this.parkinglotId = this.$route.query.parkinglotId
		this.couponTaskId = this.$route.query.couponTaskId
		// this.createUrl();
		// getCouponKey({ taskId: this.taskId }).then(res => {
		// 	this.couponKey = res.msg
		// })
	},
	methods: {
		chooseRationType() {
			this.$weui.picker(this.checkedCouponOptions, {
				onChange: result => {
					this.checkedCoupon = result[0].label;
					this.checkedCouponId = result[0].value;
				},
				onConfirm: result => {
					this.checkedCoupon = result[0].label;
					this.checkedCouponId = result[0].value;
				},
				// onClose: () => {
				//     this.userChooseCoupon()
				// },
				title: '可选优惠券'
			});
		},

		handleConfirm() {
			// this.url = scan.link + '?taskId=' + encrypt.encrypt(this.taskId) +
			// 	'&isGZH=' + true + '&isChecked=' + this.isChecked + "&isRationFee=" + true;
			const today = new Date();
			// 获取当前时间(today)的年份
			const year = today.getFullYear();
			// 获取月份
			const month = String(today.getMonth() + 1).padStart(2, '0');
			// 获取当前日
			const day = String(today.getDate()).padStart(2, '0');
			let time = `${year}-${month}-${day}`
			let Url = "http://parkinglot.scan.easthuaxin.com/weChat/paymentAdvance" + "?taskId=" + this.couponTaskId + "&prepay="+true+"&parkinglotId=" + this.parkinglotId + "&validateTime=" + this.checkedCouponId + "&time=" + time;
			let password = 'hx1234!@#$'
			let key = this.generateSignature(Url, password)



			this.url= Url + "&key=" +encodeURIComponent(key);;
		},

		generateSignature(data, secretKey) {
			return CryptoJS.HmacSHA256(data, secretKey).toString(CryptoJS.enc.Base64);
		},
		handleChange() {
			this.createUrl()
		}
	}
}
</script>

<style scoped lang="stylus">
	@import '~common/stylus/variable';
	.qrCode-wrapper{
		padding 20px 0
		display flex
		flex-direction column
		align-items center
		p{
			color #898989
			padding-bottom 20px
		}
	}
	.weui-article{
		padding-top 5px
		p {
			font-size $article-merchant-p
			color $article-p-color
			line-height 20px
		}
	}
</style>
